import { render } from "./Me.vue?vue&type=template&id=719d667c&scoped=true"
import script from "./Me.vue?vue&type=script&lang=js"
export * from "./Me.vue?vue&type=script&lang=js"

import "./Me.vue?vue&type=style&index=0&id=719d667c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\diafischchen-webpage\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719d667c"]])

export default __exports__